import { ProfileScreen } from '@components/Profile/ProfileScreen'

export default function UserEdit() {
  return <ProfileScreen />
}
